export function dataCrossingProblematicCombinationStatus (statusNumber) {
  switch (statusNumber) {
    case 0:
      return 'notChecked'
    case 1:
      return 'accepted'
    case 2:
      return 'rejected'
  }
  return 'notChecked'
}



// WEBPACK FOOTER //
// ./src/internal-app/pages/dataCrossing/dataCrossingProblematicCombinationStatus.js